import Vue from 'vue';
import { ALERT_TYPES } from './vueTypes';

export default class AlertStore {
  constructor() {
    this.instance = new Vue({
      data() {
        return {
          items: [],
          latestId: 0,
        };
      },
      methods: {
        push(message = '', type = ALERT_TYPES.INFO) {
          if (!Object.values(ALERT_TYPES).includes(type)) {
            console.error('[alert-box-plugin] Wrong type is given.');
            return;
          }

          this.latestId++;
          this.items.push({
            id: this.latestId,
            message,
            type,
          });
        },
        delete(id) {
          this.items = this.items.filter(item => item.id !== id);
        },
      },
    });
  }

  get items() {
    return this.instance.$data.items;
  }

  push(...args) {
    return this.instance.push(...args);
  }

  delete(...args) {
    this.instance.delete(...args);
  }
}
